import { GameTestDisplayProperties } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/properties/GameTestDisplayProperties";
import { GridLayout } from "@lib/titan2/dist/game/control/layout/GridLayout";
/**
 * TestDisplayLandscapeProperties.ts
 */
export class TestDisplayLandscapeProperties extends GameTestDisplayProperties {
    constructor() {
        super();
        this.position.set(0, 50);
        this.panelProperties.layout = new GridLayout(10, 4, 5, 5);
    }
}
//# sourceMappingURL=TestDisplayLandscapeProperties.js.map